import { Cancel, InsertDriveFileOutlined } from '@material-ui/icons'
import ErrorLine from 'components/ErrorLine'
import MediaPlayer from 'components/harmonize/MediaPlayer'
import TimerProgress from 'components/mint/TimerProgress'
import { log } from 'components/utility/DisplayLog'
import { downloadImageFile } from 'controllers/BackblazeController'
import { useState } from 'react'
import { useRef } from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getMediaAudio } from 'util/imageUtils'
import { getAudioUrl } from 'util/playlistUtils'
import { MEDIA_TYPES } from 'util/postUtils'
import { displayError } from 'util/screenUtils'

export default function MediaIcon({ icon, ix, imageClicked, setPosterImage }) {
    const { name, dataUrl, mimeType } = icon
    const [videoHeight, setVideoHeight] = useState(0)
    const [videoWidth, setVideoWidth] = useState(0)
    const [videoUrl, setVideoUrl] = useState()
    const [posterSrc, setPosterSrc] = useState()
    const [imageSrc, setImageSrc] = useState()
    const [audioSrc, setAudioSrc] = useState()
    const [videoSrc, setVideoSrc] = useState()
    const [error, setError] = useState()
    const videoRef = useRef(null)
    const dispatch = useDispatch()

    const displayAudio = () => {
        if (audioSrc) {
            console.log(`displayAudio ${audioSrc}`)
            return (
                <audio
                    src={audioSrc}
                    controls
                    style={{ width: '100%' }} />
            )
        }
    }

    const updatePosterImage = (posterImage) => {
        console.log('MediaIcon updatePosterImage', posterImage)
        const blob = new Blob([posterImage], { type: posterImage.type })
        setPosterSrc(URL.createObjectURL(blob))
        setPosterImage(posterImage)
    }
    const displayVideo = () => {
        if (!(videoSrc || videoUrl)) {
            return <TimerProgress />
        } else if (videoSrc) {
            console.log(`displayVideo ${videoSrc}`)
            return (
                <MediaPlayer
                    setPosterImage={setPosterImage ? updatePosterImage : undefined}
                    dispatch={dispatch}
                    source={videoSrc}
                    controls={true}
                    autoHeight={true}
                    autoplay={false}
                    videoOnly={true}
                    noPlayerControls
                    videoStyle={{ height: 'auto', maxHeight: '30vh', maxWidth: '80vw', objectFit: 'contain' }} />
            )
        }
        else if (videoUrl) {
            console.log(`displayVideoUrl ${videoWidth}x${videoHeight}`)
            if (videoWidth && videoHeight) {
                return <video ref={videoRef} controls width={videoWidth} height={videoHeight}>
                    <source src={videoUrl} type="video/mp4" />
                </video>
            } else {
                //This must be supplied so that there is a non-null videoRef 
                return <video ref={videoRef} controls width={135} height={240}>
                    <source src={videoUrl} type="video/mp4" />
                </video>
            }

        }
    }

    const displayVideoPoster = () => {
        console.log('displayVideoPoster', posterSrc)
        if (posterSrc) {
            return (
                <img
                    key={ix}
                    src={posterSrc}
                    alt={name}
                    style={{
                        maxHeight: '30vh',
                        maxWidth: '80vw',
                        display: 'flex',
                        margin: 'auto',
                    }}
                />
            )
        }
    }
    const getIcon = () => {
        if (MEDIA_TYPES.AUDIO.includes(mimeType)) {
            return (
                <div key={ix}>
                    {displayAudio()}
                </div>
            )
        } else if (MEDIA_TYPES.IMAGE.includes(mimeType)) {
            return (
                <img
                    key={ix}
                    src={imageSrc ? imageSrc : dataUrl}
                    alt={name}
                    style={{
                        width: '120px',
                        display: 'flex',
                        margin: 'auto',
                    }}
                />
            )
        } else if (MEDIA_TYPES.VIDEO.includes(mimeType)) {
            return (
                <div key={ix}>
                    {displayVideo()}
                    {displayVideoPoster()}
                </div>
            )
        }
        else {
            return (
                <div key={ix}>
                    <InsertDriveFileOutlined fontSize='large' color='secondary' />
                </div>
            )
        }
    }

    const displayIcon = () => {
        return (
            <div
                key={ix}
                style={{
                    border: '1px solid blue',
                    borderRadius: '0.5em',
                    padding: audioSrc ? '2em' : '0.25em',
                    margin: '0.5em',
                    width: audioSrc ? '75vw' : '90vw',
                    textAlign: 'center',
                }}
            >
                <ErrorLine error={error} />
                <div style={{ display: 'flex', cursor: 'pointer', justifyContent: 'center' }}
                    onClick={(evt) => {
                        evt.stopPropagation()
                        if (imageClicked) { imageClicked(ix) }
                    }}><Cancel style={{ fontSize: '2em' }} /></div>
                {getIcon()}
                <div
                    style={{ fontSize: '0.75em', textAlign: 'center', lineHeight: '1em', wordBreak: 'break-all' }}
                >
                    {name}
                </div>
            </div>
        )
    }
    /**
     * @See https://stackoverflow.com/questions/61012790/how-to-read-large-video-files-in-javascript-using-filereader
     * @param {*} file 
     * @param {*} setter 
     */
    const readAndSetFile = (file, setter) => {
        const reader = new FileReader()
        const { mimeType } = file
        reader.readAsArrayBuffer(file)
        reader.onload = function (e) {
            // The file reader gives us an ArrayBuffer:
            const buffer = e.target.result
            // We have to convert the buffer to a blob:
            const videoBlob = new Blob([new Uint8Array(buffer)], { type: mimeType })
            // The blob gives us a URL to the video file:
            const url = window.URL.createObjectURL(videoBlob)
            setter(url)
        }
    }
    const getIconMedia = async () => {
        console.log('getIconMedia', icon)
        const { source, name, mimeType, file } = icon
        if (source || file) {
            setError()
            try {
                if (MEDIA_TYPES.IMAGE.includes(mimeType)) {
                    if (source) {
                        const data = await downloadImageFile(source)
                        setImageSrc(URL.createObjectURL(data))
                    } else if (file) {
                        readAndSetFile(file, setImageSrc)
                    }
                } else if (MEDIA_TYPES.AUDIO.includes(mimeType)) {
                    if (source) {
                        const audio = getMediaAudio([{ mimeType, source, sourceName: name }])
                        const { source: audioSource, name: audioSourceName } = audio
                        const url = getAudioUrl(audioSource, audioSourceName, !audioSource.startsWith('audio/'))
                        setAudioSrc(url)
                    } else
                        if (file) {
                            readAndSetFile(file, setAudioSrc)
                        }
                } else if (MEDIA_TYPES.VIDEO.includes(mimeType)) {
                    if (source) {
                        const videoParameters = `${process.env.REACT_APP_API_KEY}/${source}/${name}`
                        const url = `${process.env.REACT_APP_CORE_SERVICE}media/${videoParameters}`
                        setVideoSrc(url)
                    } else if (file) {
                        readAndSetFile(file, setVideoUrl)
                    }
                }

            } catch (error) {
                console.error(error)
                displayError(`Unable to display image ${source}`, setError)
            }

        }
    }

    /**
     * @see https://github.com/cjpdesign/extract-video-poster/blob/master/js/main.js
     */
    const drawFrame = () => {
        if (setPosterImage) {
            try {
                const quality = parseFloat(process.env.REACT_APP_UPLOAD_IMAGE_QUALITY)
                const video = videoRef.current
                log(`MediaIcon drawFrame ${video.videoWidth}x${video.videoHeight}`)
                const canvas = window.document.createElement('canvas')
                const ctx = canvas.getContext('2d')
                canvas.width = video.videoWidth
                canvas.height = video.videoHeight
                video.pause()
                ctx.drawImage(video, 0, 0)
                canvas.toBlob((blob) => {
                    setPosterSrc(URL.createObjectURL(blob))
                    const nameOnly = name.split('.')[0]
                    const posterFile = new File([blob], `${nameOnly}-poster.jpg`, {
                        type: 'image/jpeg',
                    })
                    setPosterImage(posterFile)
                }, 'image/jpeg', quality)
            } catch (error) {
                console.error('MediaIcon drawFrame', error)
            }
        }
    }
    /**
     * Get the width and height for display purposes. Note that on ios, large videos are loaded unreliably,
     * though they can be sent to the service. Therefore we no longer use these values on the
     * Core Service -- instead they are directly read from the source mp4.
     */
    const handleMetadata = () => {
        const video = videoRef.current
        log(`Video loadedmetadata videoWidth ${video.videoWidth} videoHeight ${video.videoHeight}`)
        const aspectRatio = video.videoWidth / video.videoHeight
        const portrait = aspectRatio < 1
        let height, width
        if (portrait) {
            height = 240
            width = height * aspectRatio
        } else {
            width = 240
            height = width / aspectRatio

        }
        setVideoWidth(width)
        setVideoHeight(height)
        log(`metadata Video aspectRatio ${aspectRatio} dimensions ${width}x${height}`)
        video.muted = true
        video.play()
    }
    /**
     * Call this after the video element has been loaded by tracking videoUrl.
     * Otherwise videoRef.current is null.
     * 
     * Note that this causes intermittent ResizwObserver errors. Eff em.
     */
    useEffect(() => {
        if (videoUrl) {
            console.log(`MediaIcon useEffect ${videoUrl}`, videoRef.current)
            if (videoRef.current) {
                videoRef.current.addEventListener('loadedmetadata', handleMetadata, false)
                videoRef.current.addEventListener('timeupdate', drawFrame, false)
            }

            return () => {

                if (videoRef.current) {
                    videoRef.current.removeEventListener('loadedmetadata', handleMetadata)
                    videoRef.current.removeEventListener('timeupdate', drawFrame)
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videoUrl, videoUrl])
    /**
     * Ignore ResizeObserver errors.
     * @see https://stackoverflow.com/questions/76187282/how-to-fix-resizeobserver-loop-completed-with-undelivered-notifications
     */
    useEffect(() => {
        getIconMedia()

        function hideError(e) {
            if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
                const resizeObserverErrDiv = document.getElementById(
                    'webpack-dev-server-client-overlay-div'
                )
                const resizeObserverErr = document.getElementById(
                    'webpack-dev-server-client-overlay'
                )
                if (resizeObserverErr) {
                    resizeObserverErr.setAttribute('style', 'display: none')
                }
                if (resizeObserverErrDiv) {
                    resizeObserverErrDiv.setAttribute('style', 'display: none')
                }
            }
        }

        window.addEventListener('error', hideError)
        return () => {
            window.addEventListener('error', hideError)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return displayIcon()
}